<template>
    <div class="main-content">
        <PilotBanner />
        <div v-if="this.yearList.length == 0">
            <br>
             <div class="election-sub-title">Online Statements are not currently available. If you have any questions, please contact elections at: 
                <a href="mailto:voterinfo@rrcc.lacounty.gov">voterinfo@rrcc.lacounty.gov</a>
            </div>
        </div>
        <div v-else>
            <ElectionNavigation />
            <Filter />
            <div class="m-pad">
                <PublicContestList />
            </div>
        </div>
    </div>
</template>

<script>
import PublicContestList from '@/components/PublicContestList.vue'
import ElectionNavigation from '@/components/ElectionNavigation.vue'
import Filter from '@/components/Filter.vue'
import PilotBanner from '@/components/PilotBanner.vue'
import { mapGetters } from 'vuex';
import {  FETCH_YEARLIST } from '../store/actions.type';
export default {
    components: {
        PilotBanner,
        PublicContestList,
        ElectionNavigation,
        Filter
    },
    computed: {
        ...mapGetters(["yearList"]),
        getYearList() {
            return this.yearList ? this.yearList : [];
        },    
    },
    async beforeMount() {
            await this.$store.dispatch(FETCH_YEARLIST);
    }
}
</script>

<style>
.b-to-top {
    position: fixed;
    bottom: 1em;
    right: 1em;
}
</style>